import { render, staticRenderFns } from "./SceneCta.vue?vue&type=template&id=1dc55b37&scoped=true&lang=pug&"
import script from "./SceneCta.vue?vue&type=script&lang=js&"
export * from "./SceneCta.vue?vue&type=script&lang=js&"
import style0 from "./SceneCta.vue?vue&type=style&index=0&id=1dc55b37&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc55b37",
  null
  
)

export default component.exports